import Connection from "./Connection.svg"
import "react-responsive-modal/styles.css"
import { Modal } from "react-responsive-modal"
import { useDispatch, useSelector } from "react-redux"
import { setConnectModal, setTxModalClose, setShowGetUsdceModal } from "../../ReduxSlices/ModalSlice"
import Lottie from "lottie-react"
import hourGlass from "../../assets/animations/timeglass.json"
import checkMarkJson from "../../assets/animations/Check mark.json"
import confettiJson from "../../assets/animations/Confetti.json"
import failed from "../../assets/animations/failed.json"
import { useLocation, useNavigate } from "react-router-dom"
import { setConnect } from "../../ReduxSlices/AuthSlice"
import { useEffect, useState } from "react"
import { Mainnet } from "@nibiruchain/nibijs"
import { toast } from "react-toastify"
import { api } from "../functions/Api"
import ClipLoader from "react-spinners/ClipLoader"
import KeplrIcon from "../../assets/images/Keplr_icon_ver.1.3_2.svg"
import ThirdwebIcon from "../../assets/images/thirdweb.svg"
import { X, ChevronRight, Info, Smartphone, Monitor } from "lucide-react"
import { Logo } from "../../AssetComponents/Images"
import Chevron from "./Chevron.svg"
import { connectLeapWallet, disconnectLeapWallet } from "../../Services/leapWalletConnectService"
import { isMobileDevice } from "../../utils/deviceDetection"
import { getEthereumProvider } from "../../evm/services/EvmContract"
import { NIBIRU_EVM_NETWORK_NAME, NIBIRU_EVM_CHAIN } from "../../evm/EvmConstants"
import { useConnectModal } from "thirdweb/react"
import { thiredWebClient, nibiruChain, thirdwebWallets } from "../functions/Functions"

/**
 * RENTAL PRODUCT CONNECT MODAL
 *
 * Wallet options: MetaMask (EVM), Keplr, Leap (Cosmos).
 * For Keplr/Leap, bookings use USDC.e on Nibiru; we show a "Get USDC.e" modal after connect.
 */

const getNetworkName = (chainId) => {
  switch (chainId) {
    case "cataclysm-1":
      return "Nibiru Mainnet"
    case "nibiru-testnet-2":
      return "Nibiru Testnet 2"
    case "nibiru-devnet-3":
      return "Nibiru Devnet 3"
    case "0x1AFF":
      return "Nibiru EVM"
    default:
      return "Connect to Nibiru!"
  }
}

export const TransactionModal = () => {
  const dispatch = useDispatch()
  const onCloseModal = async () => {
    await new Promise((resolve) => setTimeout(resolve, 2000))
    toast.dismiss()
    dispatch(setTxModalClose())
  }
  const open = useSelector((state) => state.modal.transactionModal)
  const txStatus = useSelector((state) => state.modal.txStatus)
  const onCloseModalImmediate = () => {
    toast.dismiss()
    dispatch(setTxModalClose())
  }

  return (
    <Modal
      open={open}
      onClose={onCloseModalImmediate}
      center
      showCloseIcon={true}
      closeOnEsc={true}
      closeOnOverlayClick={false}
      classNames={{
        modal:
          "min-w-[350px] h-max rounded-[8px] border-[1px] border-[#E3E3E3] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]",
        closeIcon: "fill-gray-600 hover:fill-gray-800",
      }}
    >
      <div className="h-[210px] flex flex-col justify-between">
        {txStatus === false && (
          <>
            <div className="text-[20px] font-semibold">Transaction Failed</div>
            <Lottie animationData={failed} loop={false} className="m-auto w-[160px]" onComplete={onCloseModal} />
            <div className="w-full text-center">Your transaction is failed</div>
          </>
        )}
        {txStatus === true && (
          <>
            <div className="sm:max-w-[300px] relative" style={{ height: "210px", overflow: "hidden" }}>
              <div className="top-0 absolute">
                <Lottie animationData={confettiJson} loop={false} />
              </div>
              <div className="">
                <Lottie animationData={checkMarkJson} loop={false} onComplete={onCloseModal} />
              </div>
              <div className="text-[20px] font-semibold w-full flex flex-col items-center absolute top-[160px]">
                <div className="">Transaction Confirmed</div>
              </div>
            </div>
          </>
        )}

        {txStatus === null && (
          <>
            <div className="text-[20px] font-semibold">Transaction in Process</div>
            <Lottie animationData={hourGlass} className="w-[140px] mx-auto max-h-[100px]" />
            <div className="w-full text-center">Finalizing Transaction</div>
          </>
        )}
      </div>
    </Modal>
  )
}

export const ConnectModal = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const open = useSelector((state) => state.modal.connectModal)
  const account_ = useSelector((state) => state.auth.account)
  const walletType = useSelector((state) => state.auth.wallet)
  const location = useLocation()
  const [loading, setLoading] = useState(false)
  const [loadingWallet, setLoadingWallet] = useState(null)
  const [isWalletSectionOpen, setIsWalletSectionOpen] = useState(true)
  const showGetUsdceModal = useSelector((state) => state.modal.showGetUsdceModal)
  const { connect: openThirdwebConnectModal } = useConnectModal()

  // Check if user is on a rental page
  const isRentalPage = location.pathname.includes('/rent') ||
    location.pathname.includes('/rental') ||
    location.pathname.includes('/booking')

  const onCloseModal = () => {
    dispatch(setConnectModal(false))
    if (!account_) navigate(location.pathname)
  }

  // Handle redirection after successful wallet connection
  const handlePostConnectionRedirection = () => {
    const destination = sessionStorage.getItem('postWalletDestination')
    const action = sessionStorage.getItem('postWalletAction')

    if (destination && action) {
      console.log('Redirecting after wallet connection:', { destination, action })

      // Clear the session storage
      sessionStorage.removeItem('postWalletDestination')
      sessionStorage.removeItem('postWalletAction')

      // Navigate to the intended destination
      navigate(destination)
    }
  }

  const connectToBackend = async (account_) => {
    try {
      console.log("Connecting to backend with account:", account_)
      const res = await api("user/login", {
        account: account_,
      })
      console.log("Backend connection successful:", res)
      return res
    } catch (error) {
      console.error("Backend connection failed:", error)
      return null
    }
  }

  const handleConnect = async (wallet) => {
    try {
      setLoadingWallet(wallet)
      setLoading(true)

      if (wallet === "leap") {
        // Check if mobile device
        if (isMobileDevice()) {
          console.log("Mobile device detected")

          // Check if we're already in Leap Wallet's browser
          if (window.leap) {
            console.log("Already in Leap Wallet browser - connecting directly")

            try {
              const result = await connectLeapWallet()

              if (result.success && result.address) {
                dispatch(
                  setConnect({
                    account: result.address,
                    wallet: 'leap',
                  }),
                )

                await connectToBackend(result.address)

                toast.success(`🎉 Successfully connected to Leap Wallet!`, {
                  autoClose: 3000,
                })

                dispatch(setConnectModal(false))

                // Handle redirection after successful wallet connection
                handlePostConnectionRedirection()

                // Additional verification after modal closes
                setTimeout(() => {
                  console.log("Leap: Modal closed, final Redux state check (mobile direct)")
                  // Check if Redux state was properly updated
                  const currentState = window.store?.getState?.()
                  if (currentState) {
                    console.log("Leap: Final Redux state:", {
                      account: currentState.auth?.account,
                      wallet: currentState.auth?.wallet,
                      isConnected: currentState.auth?.isConnected
                    })
                  }
                }, 100)
              } else {
                throw new Error("Failed to get wallet address")
              }
            } catch (error) {
              console.error("Direct connection error:", error)
              toast.error(`Connection failed: ${error.message}`)
            }
          } else {
            // Not in Leap Wallet browser - open the app
            console.log("Opening Leap Wallet app")

            try {
              // Show instruction to user
              toast.info(
                "🚀 Opening Leap Wallet app...\n\n" +
                "Please continue the connection process in the Leap Wallet app.",
                {
                  autoClose: 5000,
                  style: { whiteSpace: 'pre-line' }
                }
              )

              const result = await connectLeapWallet()

              // This shouldn't reach here for mobile redirect, but handle just in case
              if (result.success && result.address) {
                dispatch(
                  setConnect({
                    account: result.address,
                    wallet: 'leap',
                  }),
                )

                await connectToBackend(result.address)

                toast.success(`🎉 Successfully connected to Leap Wallet!`, {
                  autoClose: 3000,
                })

                dispatch(setConnectModal(false))

                // Handle redirection after successful wallet connection
                handlePostConnectionRedirection()

                // Additional verification after modal closes
                setTimeout(() => {
                  console.log("Leap: Modal closed, final Redux state check (mobile app)")
                  // Check if Redux state was properly updated
                  const currentState = window.store?.getState?.()
                  if (currentState) {
                    console.log("Leap: Final Redux state:", {
                      account: currentState.auth?.account,
                      wallet: currentState.auth?.wallet,
                      isConnected: currentState.auth?.isConnected
                    })
                  }
                }, 100)
              }
            } catch (wcError) {
              console.error("App opening error:", wcError)

              let errorMessage = wcError?.message || wcError?.toString() || 'Unknown connection error'
              if (errorMessage.includes('continue the connection process')) {
                // This is expected for mobile redirect
                toast.info(
                  "Leap Wallet app should now be opening.\n\n" +
                  "Please navigate to this page within the Leap Wallet app and try connecting again.",
                  {
                    autoClose: 8000,
                    style: { whiteSpace: 'pre-line' }
                  }
                )
                return // Don't show this as an error
              } else if (wcError.message.includes('Failed to open')) {
                errorMessage = "Unable to open Leap Wallet app. Please install it from your app store."
              }

              toast.error(`Connection failed: ${errorMessage}`, {
                autoClose: 6000
              })
            }
          }
        } else {
          // Desktop - use direct wallet integration or WalletConnect
          console.log("Desktop device detected")

          if (window.leap) {
            // Use browser extension
            console.log("Using Leap browser extension")

            try {
              const mainnet = Mainnet()
              console.log("Leap: Mainnet object:", mainnet)
              console.log("Leap: Chain ID:", mainnet.chainId)
              console.log("Leap: Endpoint:", mainnet.endptTm)

              const tryEnableLeap = async (retries = 3) => {
                try {
                  await window.leap.enable(mainnet.chainId)
                  return true
                } catch (err) {
                  const msg = (err?.message || '').toLowerCase()
                  // Common locked/rejected messages – we prompt the user and retry shortly
                  if (retries > 0 && (msg.includes('locked') || msg.includes('keystore') || msg.includes('reject'))) {
                    // Attempt to focus the extension by calling enable again after a short delay
                    toast.info('Please unlock Leap Wallet in the popup to continue...', { autoClose: 2500 })
                    await new Promise(r => setTimeout(r, 2000))
                    return await tryEnableLeap(retries - 1)
                  }
                  throw err
                }
              }

              try {
                await tryEnableLeap()
              } catch (enableErr) {
                toast.error(
                  'Leap Wallet is locked. Please open the extension and unlock it, then try connecting again.',
                  { autoClose: 5000 }
                )
                throw enableErr
              }
              console.log("Leap: Chain enabled successfully")

              const offlineSigner = window.leap.getOfflineSigner(mainnet.chainId)
              console.log("Leap: Got offline signer")

              const accounts = await offlineSigner.getAccounts()
              console.log("Leap: Got accounts:", accounts)

              if (!accounts || accounts.length === 0) {
                throw new Error("No accounts found in Leap")
              }

              const accountAddress = accounts[0].address
              console.log("Leap: Using account address:", accountAddress)
              console.log("Leap: Account address type:", typeof accountAddress)
              console.log("Leap: Account address length:", accountAddress.length)
              console.log("Leap: Account address format check:", accountAddress.startsWith('nibi') ? 'bech32' : 'unknown')

              // Set connection state in Redux
              console.log("Leap: Dispatching setConnect with:", { account: accountAddress, wallet: wallet })
              dispatch(
                setConnect({
                  account: accountAddress,
                  wallet: wallet,
                }),
              )
              console.log("Leap: Redux state updated")

              // Small delay to ensure Redux state is properly updated
              await new Promise(resolve => setTimeout(resolve, 100))
              console.log("Leap: Redux state update delay completed")

              // Connect to backend
              const backendResult = await connectToBackend(accountAddress)
              console.log("Leap: Backend connection result:", backendResult)

              toast.success(`Connected to ${getNetworkName(mainnet.chainId)}`, {
                autoClose: 3000,
              })

              dispatch(setConnectModal(false))

              // Additional verification after modal closes
              setTimeout(() => {
                console.log("Leap: Modal closed, final Redux state check")
                // Check if Redux state was properly updated
                const currentState = window.store?.getState?.()
                if (currentState) {
                  console.log("Leap: Final Redux state:", {
                    account: currentState.auth?.account,
                    wallet: currentState.auth?.wallet,
                    isConnected: currentState.auth?.isConnected
                  })
                }
              }, 100)
            } catch (error) {
              console.error("Leap connection error:", error)
              throw error
            }
          } else {
            // Use WalletConnect with QR code
            console.log("Using WalletConnect QR code")

            try {
              const result = await connectLeapWallet()

              if (result.success && result.address) {
                dispatch(
                  setConnect({
                    account: result.address,
                    wallet: 'leap',
                  }),
                )

                await connectToBackend(result.address)

                toast.success(`🎉 Successfully connected to Leap Wallet!`, {
                  autoClose: 3000,
                })

                dispatch(setConnectModal(false))

                // Handle redirection after successful wallet connection
                handlePostConnectionRedirection()

                // Additional verification after modal closes
                setTimeout(() => {
                  console.log("Leap: Modal closed, final Redux state check (WalletConnect)")
                  // Check if Redux state was properly updated
                  const currentState = window.store?.getState?.()
                  if (currentState) {
                    console.log("Leap: Final Redux state:", {
                      account: currentState.auth?.account,
                      wallet: currentState.auth?.wallet,
                      isConnected: currentState.auth?.isConnected
                    })
                  }
                }, 100)
              } else {
                throw new Error("Failed to get wallet address")
              }
            } catch (wcError) {
              console.error("WalletConnect error:", wcError)

              let errorMessage = wcError.message
              if (wcError.message.includes('cancelled')) {
                errorMessage = "Connection was cancelled. Please try again and scan the QR code with Leap Wallet mobile app."
              } else if (wcError.message.includes('timeout')) {
                errorMessage = "Connection timed out. Please install Leap Wallet browser extension or scan the QR code with Leap Wallet mobile app."
              }

              toast.error(`Connection failed: ${errorMessage}`, {
                autoClose: 6000
              })
            }
          }
        }
      } else if (wallet === "keplr") {
        if (!window.keplr) {
          toast.info("Keplr wallet is not installed. Opening Keplr's official site in a new tab...", {
            autoClose: 4000
          })
          // Open Keplr's official site in a new tab
          window.open("https://www.keplr.app/", "_blank")
          return
        }

        // Check if mobile device and not in Keplr's built-in browser
        if (isMobileDevice() && !window.keplr.isKeplr) {
          toast.info(
            "Type in rental.codedestate.com in the Keplr Wallet App built-in Browser to proceed",
            {
              autoClose: 8000,
              style: { whiteSpace: 'pre-line' }
            }
          )
          return
        }

        try {
          const mainnet = Mainnet()
          console.log("Keplr: Mainnet object:", mainnet)
          console.log("Keplr: Chain ID:", mainnet.chainId)
          console.log("Keplr: Endpoint:", mainnet.endptTm)

          // Check if Keplr supports the chain info method and if chain is already configured
          let currentChainInfo = null
          let chainNeedsToBeAdded = false

          if (window.keplr.getChainInfo) {
            try {
              currentChainInfo = await window.keplr.getChainInfo(mainnet.chainId)
              console.log("Keplr: Current chain info:", currentChainInfo)
            } catch (chainError) {
              console.log("Keplr: Chain not found, will add it")
              chainNeedsToBeAdded = true
            }
          } else {
            console.log("Keplr: getChainInfo not supported, will attempt to add chain")
            chainNeedsToBeAdded = true
          }

          // Add the Nibiru chain configuration if it's not already present
          if (chainNeedsToBeAdded) {
            try {
              console.log("Keplr: Adding Nibiru chain configuration...")
              await window.keplr.experimentalSuggestChain({
                chainId: mainnet.chainId,
                chainName: "Nibiru",
                rpc: mainnet.endptTm,
                rest: "https://lcd.nibiru.fi", // Use the correct LCD endpoint
                bip44: {
                  coinType: 118,
                },
                bech32Config: {
                  bech32PrefixAccAddr: "nibi",
                  bech32PrefixAccPub: "nibipub",
                  bech32PrefixValAddr: "nibivaloper",
                  bech32PrefixValPub: "nibivaloperpub",
                  bech32PrefixConsAddr: "nibivalcons",
                  bech32PrefixConsPub: "nibivalconspub",
                },
                currencies: [
                  {
                    coinDenom: "NIBI",
                    coinMinimalDenom: "unibi",
                    coinDecimals: 6,
                  },
                ],
                feeCurrencies: [
                  {
                    coinDenom: "NIBI",
                    coinMinimalDenom: "unibi",
                    coinDecimals: 6,
                    gasPriceStep: {
                      low: 0.05,
                      average: 0.1,
                      high: 0.2,
                    },
                  },
                ],
                stakeCurrency: {
                  coinDenom: "NIBI",
                  coinMinimalDenom: "unibi",
                  coinDecimals: 6,
                },
              })
              console.log("Keplr: Chain configuration added successfully")
            } catch (addChainError) {
              console.error("Keplr: Failed to add chain configuration:", addChainError)
              // If adding fails, try to continue with existing configuration
              console.log("Keplr: Continuing with existing configuration...")
            }
          }

          // Enable the chain
          await window.keplr.enable(mainnet.chainId)
          console.log("Keplr: Chain enabled successfully")

          // Verify chain is enabled (if supported)
          let enabledChains = null
          if (window.keplr.getChainInfo) {
            try {
              enabledChains = await window.keplr.getChainInfo(mainnet.chainId)
              console.log("Keplr: Enabled chain info:", enabledChains)
            } catch (error) {
              console.log("Keplr: Could not verify chain info, but continuing")
            }
          }

          const offlineSigner = window.keplr.getOfflineSigner(mainnet.chainId)
          console.log("Keplr: Got offline signer")

          const accounts = await offlineSigner.getAccounts()
          console.log("Keplr: Got accounts:", accounts)

          if (!accounts || accounts.length === 0) {
            throw new Error("No accounts found in Keplr")
          }

          const accountAddress = accounts[0].address
          console.log("Keplr: Using account address:", accountAddress)
          console.log("Keplr: Account address type:", typeof accountAddress)
          console.log("Keplr: Account address length:", accountAddress.length)
          console.log("Keplr: Account address format check:", accountAddress.startsWith('nibi') ? 'bech32' : 'unknown')

          // Additional validation
          if (!accountAddress || typeof accountAddress !== 'string') {
            throw new Error("Invalid account address format from Keplr")
          }

          if (accountAddress.length < 30) {
            console.warn("Keplr: Account address seems unusually short:", accountAddress)
          }

          // Set connection state in Redux
          console.log("Keplr: Dispatching setConnect with:", { account: accountAddress, wallet: wallet })
          dispatch(
            setConnect({
              account: accountAddress,
              wallet: wallet,
            }),
          )
          console.log("Keplr: Redux state updated")

          // Small delay to ensure Redux state is properly updated
          await new Promise(resolve => setTimeout(resolve, 100))
          console.log("Keplr: Redux state update delay completed")

          // Connect to backend
          const backendResult = await connectToBackend(accountAddress)
          console.log("Keplr: Backend connection result:", backendResult)

          // Verify Redux state was set correctly
          console.log("Keplr: About to close modal, checking Redux state...")

          toast.success(`Connected to ${getNetworkName(mainnet.chainId)}`, {
            autoClose: 3000,
          })

          dispatch(setConnectModal(false))

          // Handle redirection after successful wallet connection
          handlePostConnectionRedirection()

          // Additional verification after modal closes
          setTimeout(() => {
            console.log("Keplr: Modal closed, final Redux state check")
            // Check if Redux state was properly updated
            const currentState = window.store?.getState?.()
            if (currentState) {
              console.log("Keplr: Final Redux state:", {
                account: currentState.auth?.account,
                wallet: currentState.auth?.wallet,
                isConnected: currentState.auth?.isConnected
              })
            }
          }, 100)
        } catch (error) {
          console.error("Keplr connection error:", error)
          throw error
        }
      } else if (wallet === "metamask") {
        // Check if mobile device
        if (isMobileDevice()) {
          console.log("Mobile device detected for MetaMask")

          // Check if we're already in MetaMask's in-app browser
          if (window.ethereum && (window.ethereum.isMetaMask || window.ethereum.isTrust || window.ethereum.isCoinbaseWallet)) {
            console.log("Already in an EVM wallet browser - connecting directly")

            // Use existing MetaMask connection logic
            const accounts = await window.ethereum.request({
              method: "eth_requestAccounts",
            })

            if (!accounts || accounts.length === 0) {
              throw new Error("No accounts found in Wallet")
            }

            const chainId = await window.ethereum.request({ method: "eth_chainId" })
            const targetChainId = NIBIRU_EVM_CHAIN.chainId // Always Mainnet 0x1AF4

            if (chainId !== targetChainId) {
              try {
                await window.ethereum.request({
                  method: "wallet_switchEthereumChain",
                  params: [{ chainId: targetChainId }],
                })
              } catch (switchError) {
                if (switchError.code === 4902) {
                  try {
                    await window.ethereum.request({
                      method: "wallet_addEthereumChain",
                      params: [NIBIRU_EVM_CHAIN],
                    })
                  } catch (addError) {
                    throw new Error("Failed to add Nibiru EVM network to Wallet")
                  }
                } else {
                  throw new Error("Failed to switch to Nibiru EVM network")
                }
              }
            }

            const ethAddress = accounts[0]

            dispatch(
              setConnect({
                account: ethAddress,
                wallet: wallet,
              }),
            )

            await connectToBackend(ethAddress)

            toast.success(`Connected to ${NIBIRU_EVM_NETWORK_NAME}`, {
              autoClose: 3000,
            })

            dispatch(setConnectModal(false))
            handlePostConnectionRedirection()
          } else {
            // Not in MetaMask browser - redirect to MetaMask app
            console.log("Opening MetaMask app")

            // Show instruction to user
            toast.info(
              "Opening MetaMask app...\n\n" +
              "Please continue the connection process in the MetaMask app.",
              {
                autoClose: 5000,
                style: { whiteSpace: 'pre-line' }
              }
            )

            // Check current page to determine redirect URL
            const currentPath = window.location.pathname;
            const redirectUrl = `https://metamask.app.link/dapp/rental.codedestate.com${currentPath}`;

            // Redirect to MetaMask app with appropriate deeplink
            setTimeout(() => {
              window.location.href = redirectUrl;
            }, 500)
          }
        } else {
          // Desktop - use existing MetaMask logic
          if (!window.ethereum) {
            toast.error("MetaMask is not installed")
            return
          }

          const accounts = await window.ethereum.request({
            method: "eth_requestAccounts",
          })

          if (!accounts || accounts.length === 0) {
            throw new Error("No accounts found in MetaMask")
          }

          const chainId = await window.ethereum.request({ method: "eth_chainId" })
          const targetChainId = NIBIRU_EVM_CHAIN.chainId // Always Mainnet 0x1AF4

          if (chainId !== targetChainId) {
            try {
              await window.ethereum.request({
                method: "wallet_switchEthereumChain",
                params: [{ chainId: targetChainId }],
              })
            } catch (switchError) {
              // This error code indicates that the chain has not been added to MetaMask.
              if (switchError.code === 4902) {
                try {
                  await window.ethereum.request({
                    method: "wallet_addEthereumChain",
                    params: [NIBIRU_EVM_CHAIN],
                  })
                } catch (addError) {
                  throw new Error("Failed to add Nibiru EVM network to MetaMask")
                }
              } else {
                throw new Error("Failed to switch to Nibiru EVM network")
              }
            }
          }

          const ethAddress = accounts[0]

          dispatch(
            setConnect({
              account: ethAddress,
              wallet: wallet,
            }),
          )

          await connectToBackend(ethAddress)

          toast.success(`Connected to ${NIBIRU_EVM_NETWORK_NAME}`, {
            autoClose: 3000,
          })

          dispatch(setConnectModal(false))
          handlePostConnectionRedirection()
        }
      } else if (wallet === "thirdweb") {
        // Thirdweb social login (email / google / apple / facebook / coinbase / passkey)
        try {
          const connectedWallet = await openThirdwebConnectModal({
            client: thiredWebClient,
            chain: nibiruChain,
            wallets: thirdwebWallets,
            title: "Sign in",
            showThirdwebBranding: false,
          })

          const account = connectedWallet?.getAccount?.()
          const address = account?.address
          if (!address) {
            throw new Error("No account returned from thirdweb")
          }

          dispatch(
            setConnect({
              account: address,
              wallet: "thirdweb",
            })
          )

          await connectToBackend(address)

          toast.success(`Connected via social login`, {
            autoClose: 3000,
          })

          dispatch(setConnectModal(false))
          handlePostConnectionRedirection()
        } catch (twError) {
          // Users cancelling the thirdweb modal shouldn't look like a hard error
          const msg = twError?.message || ""
          if (msg.toLowerCase().includes("cancel") || msg.toLowerCase().includes("closed")) {
            return
          }
          console.error("Thirdweb social login error:", twError)
          toast.error(`Social login failed: ${msg || "Please try again."}`)
        }
      } else {
        toast.error("Unsupported wallet type. Please use MetaMask, Keplr, Leap, or Social Login.")
        return
      }
    } catch (error) {
      console.error(`Error connecting to ${wallet}:`, error)
      toast.error(`Cannot connect to your ${wallet} wallet: ${error.message}`)
    } finally {
      setLoading(false)
      setLoadingWallet(null)
    }
  }

  useEffect(() => {
    if (account_) {
      const networkLabel = walletType === "metamask" || walletType === "bybitWallet" ? NIBIRU_EVM_NETWORK_NAME : "Nibiru (Cosmos)"
      console.log("Wallet connected:", { type: walletType || "unknown", account: account_, network: networkLabel })
      onCloseModal()
    }
  }, [account_, walletType])

  useEffect(() => {
    if (open) {
      setLoading(false)
      setLoadingWallet(null)
      // Prevent body scrolling when modal is open
      document.body.style.overflow = 'hidden'
      document.body.style.position = 'fixed'
      document.body.style.width = '100%'
    } else {
      // Restore body scrolling when modal is closed
      document.body.style.overflow = 'unset'
      document.body.style.position = 'static'
      document.body.style.width = 'auto'
    }

    // Cleanup function to restore body scrolling
    return () => {
      document.body.style.overflow = 'unset'
      document.body.style.position = 'static'
      document.body.style.width = 'auto'
    }
  }, [open])

  return (
    <>
      {open && (
        <div
          className="fixed inset-0 bg-black/50 z-40 flex items-center justify-center p-4"
          onClick={onCloseModal}
        >
          <div
            className="w-[95vw] sm:w-[90vw] md:w-[480px] max-w-[480px] min-w-[280px] rounded-[12px] sm:rounded-[16px] bg-white shadow-xl border-0 p-0 z-50 max-h-[90vh] overflow-y-auto"
            onClick={(e) => e.stopPropagation()}
            style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              margin: 0,
              padding: 0,
            }}
          >
            <div className="relative">
              <button
                onClick={onCloseModal}
                className="absolute top-3 right-3 sm:top-4 sm:right-4 p-1.5 sm:p-2 hover:bg-gray-100 rounded-full transition-colors z-10"
              >
                <X className="w-4 h-4 sm:w-5 sm:h-5 text-gray-500" />
              </button>
              <div className="text-center pt-6 sm:pt-8 pb-4 sm:pb-6 px-4 sm:px-6">
                <div className="flex justify-center mb-3 sm:mb-4">
                  <Logo />
                </div>
                <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-2">Connect to Coded Estate</h2>
                <p className="text-gray-600 text-xs sm:text-sm px-2">Book stays, unlock rewards, and explore crypto travel.</p>
              </div>

              <div className="px-4 sm:px-6 pb-4 sm:pb-6 space-y-4">
                {/* Connecting Existing Wallet Section */}
                <div className="border border-gray-200 rounded-lg p-3 sm:p-4">
                  <div className="flex items-center justify-between mb-3 sm:mb-4">
                    <div className="flex items-center space-x-2 sm:space-x-3">
                      <img src={Connection} alt="Connection Icon" className="w-6 h-6 sm:w-8 sm:h-8 flex-shrink-0" />
                      <div className="min-w-0">
                        <h3 className="font-semibold text-gray-900 text-sm sm:text-base">Connecting Existing Wallet</h3>
                        <p className="text-xs sm:text-sm text-gray-600 truncate">Already have a wallet? Connect now.</p>
                      </div>
                    </div>
                    <button
                      onClick={() => setIsWalletSectionOpen(!isWalletSectionOpen)}
                      className={`transition-transform duration-200 ${isWalletSectionOpen ? 'rotate-90' : ''}`}
                    >
                      <img src={Chevron} alt="Chevron Icon" className="w-5 h-5" />
                    </button>
                  </div>

                  {/* Wallet Options: all 4 in one line (same as Perps) */}
                  {isWalletSectionOpen && (
                    <div className="pt-4 border-t border-gray-100 space-y-3">
                      <div className="grid grid-cols-4 gap-2 sm:gap-3">
                        {/* MetaMask - EVM (mainnet) */}
                        <button
                          onClick={() => handleConnect("metamask")}
                          disabled={loading}
                          className="flex flex-col items-center p-2 sm:p-3 rounded-lg hover:bg-gray-50 transition-colors disabled:opacity-50"
                        >
                          {loadingWallet === "metamask" ? (
                            <ClipLoader size={28} />
                          ) : (
                            <img
                              src="https://upload.wikimedia.org/wikipedia/commons/3/36/MetaMask_Fox.svg"
                              alt="MetaMask"
                              className="w-7 h-7 sm:w-8 sm:h-8 mb-1.5 sm:mb-2"
                            />
                          )}
                          <span className="text-[10px] sm:text-xs text-gray-700 font-medium">Metamask</span>
                        </button>
                        {/* Keplr - Cosmos */}
                        <button
                          onClick={() => handleConnect("keplr")}
                          disabled={loading}
                          className="flex flex-col items-center p-2 sm:p-3 rounded-lg hover:bg-gray-50 transition-colors disabled:opacity-50"
                        >
                          {loadingWallet === "keplr" ? (
                            <ClipLoader size={28} />
                          ) : (
                            <img src={KeplrIcon || "/placeholder.svg"} alt="Keplr" className="w-7 h-7 sm:w-8 sm:h-8 mb-1.5 sm:mb-2" />
                          )}
                          <span className="text-[10px] sm:text-xs text-gray-700 font-medium">Keplr</span>
                        </button>
                        {/* Leap - Cosmos */}
                        <button
                          onClick={() => handleConnect("leap")}
                          disabled={loading}
                          className="flex flex-col items-center p-2 sm:p-3 rounded-lg hover:bg-gray-50 transition-colors disabled:opacity-50"
                        >
                          {loadingWallet === "leap" ? (
                            <ClipLoader size={28} />
                          ) : (
                            <img
                              src="https://assets.leapwallet.io/logos/leap-cosmos-logo.svg"
                              alt="Leap"
                              className="w-7 h-7 sm:w-8 sm:h-8 mb-1.5 sm:mb-2"
                            />
                          )}
                          <span className="text-[10px] sm:text-xs text-gray-700 font-medium">Leap</span>
                        </button>
                        {/* Social Login (Thirdweb: email / Google / Apple / Facebook / Coinbase / Passkey) */}
                        <button
                          onClick={() => handleConnect("thirdweb")}
                          disabled={loading}
                          className="flex flex-col items-center p-2 sm:p-3 rounded-lg hover:bg-gray-50 transition-colors disabled:opacity-50"
                        >
                          {loadingWallet === "thirdweb" ? (
                            <ClipLoader size={28} />
                          ) : (
                            <div className="w-7 h-7 sm:w-8 sm:h-8 mb-1.5 sm:mb-2 flex items-center justify-center">
                              <img
                                src={ThirdwebIcon}
                                alt="Social Login"
                                className="w-full h-full object-contain"
                              />
                            </div>
                          )}
                          <span className="text-[10px] sm:text-xs text-gray-700 font-medium">Social Login</span>
                        </button>
                      </div>
                    </div>
                  )}
                </div>

                <div className="flex items-center justify-center pt-3 sm:pt-4">
                  <button className="flex items-center space-x-2 text-xs sm:text-sm text-gray-600 hover:text-gray-800 transition-colors">
                    <Info className="w-3 h-3 sm:w-4 sm:h-4" />
                    <span>Learn more about wallet options</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Get USDC.e detail modal (opened from Confirm page when user has Keplr/Leap) */}
      <Modal
        open={showGetUsdceModal}
        onClose={() => dispatch(setShowGetUsdceModal(false))}
        center
        closeOnOverlayClick={true}
        closeOnEsc={true}
        classNames={{
          modal:
            "relative max-w-[420px] w-[95vw] md:max-w-[420px] md:w-[95vw] bg-white p-4 sm:p-6 rounded-2xl shadow-xl border border-gray-100 mx-auto max-h-[90vh] overflow-y-auto",
        }}
      >
        <div className="space-y-4">
          <h2 className="text-lg sm:text-xl font-semibold text-gray-900">
            Get USDC.e for bookings
          </h2>
          <p className="text-sm text-gray-600 leading-relaxed">
            Listings on CodedEstate use <span className="font-semibold">USDC.e</span> (canonical USDC on Nibiru).
            If you use Keplr or Leap, you need USDC.e—not USDC from Noble. Use one of the options below to get it.
          </p>
          <ol className="space-y-2 text-sm text-gray-700 list-decimal list-inside leading-relaxed">
            <li>
              Open the <span className="font-semibold">Nibiru app</span> or <span className="font-semibold">Sai app</span> deposit / bridge screen.
            </li>
            <li>
              Select a <span className="font-semibold">source chain</span> (Ethereum, Arbitrum, Base, etc.) and set <span className="font-semibold">destination</span> to <span className="font-semibold">Nibiru</span>.
            </li>
            <li>
              Choose <span className="font-semibold">USDC.e</span> (or USD Coin) and enter the amount.
            </li>
            <li>
              Enter your <span className="font-semibold">Nibiru address</span> as recipient (copy it below if needed).
            </li>
            <li>
              Confirm the transaction; funds usually arrive in a few minutes.
            </li>
          </ol>
          {account_ && (walletType === "keplr" || walletType === "leap") && (
            <div className="rounded-lg bg-gray-50 border border-gray-200 p-3">
              <p className="text-xs font-medium text-gray-600 mb-1">Your Nibiru address (use as recipient)</p>
              <div className="flex items-center gap-2">
                <code className="text-xs text-gray-800 truncate flex-1 font-mono">{account_}</code>
                <button
                  type="button"
                  onClick={() => {
                    navigator.clipboard?.writeText(account_)
                    toast.success("Address copied")
                  }}
                  className="flex-shrink-0 px-2 py-1 text-xs font-medium text-gray-700 bg-white border border-gray-300 rounded hover:bg-gray-50"
                >
                  Copy
                </button>
              </div>
            </div>
          )}
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-3 text-xs text-blue-800">
            <p className="font-semibold mb-1">Tip</p>
            <p className="leading-tight">
              You need a small amount of gas on the source chain to complete the bridge. On Nibiru mainnet, transaction fees are paid in NIBI—you may need to obtain NIBI from an exchange or the Nibiru app.
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-2 pt-1">
            <a
              href="https://app.nibiru.fi/bridge"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center px-4 py-2.5 text-sm font-medium text-white bg-[#5B1DEE] rounded-lg hover:opacity-90 transition-opacity"
            >
              Open Nibiru Bridge
            </a>
            <a
              href="https://sai.nibiru.fi"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center px-4 py-2.5 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
            >
              Open Sai app
            </a>
          </div>
        </div>
      </Modal>
    </>
  )
}

